export enum TestDriveMode {
  BOOKING = 'BOOKING',
  EXTENDED = 'EXTENDED',
  REQUEST = 'REQUEST',
}

export enum TestDriveModeSummaryBadgeLabel {
  BOOKING = 'booking',
  REQUEST = 'underRequest',
}

export enum TestDriveModeSummaryPostTitleLabel {
  BOOKING = 'Booking',
  REQUEST = 'Request',
}
